import React, { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
import BackButton from "../BackButton";
import InputTextFieldGrid from "../common/InputTextFieldGrid";
import InputImageFieldGrid from "../common/InputImageFieldGrid";
import CheckboxFieldGrid from "components/common/CheckboxFieldGrid";
import CustomButton from "components/CustomButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TableData from "components/common/TableData";
import { AddOutlined, Close } from "@mui/icons-material";

const ProductForm = ({ defaultValues, submit, type }) => {
  const navigate = useNavigate();
  const { currentPDSSegment, justPDSProducts } = useSelector((state) => state.products);
  const { control, handleSubmit, setValue } = useForm({ defaultValues });
  const watch = useWatch({ control });

  useEffect(() => {
    if (watch.fixedAmount) {
      setValue('code', '')
      setValue('chargeService', false)
    } else {
      setValue('amounts', [])
    }
    // eslint-disable-next-line
  }, [watch.fixedAmount])

  useEffect(() => {
    if (watch.chargeService) {
      setValue('fixedAmount', false)
    }
    // eslint-disable-next-line
  }, [watch.chargeService])

  useEffect(() => {
    if (watch.referenceVariable) {
      setValue('referenceLength', '')
    }
    // eslint-disable-next-line
  }, [watch.referenceVariable])

  useEffect(() => {
    if (!watch.chargeService) {
      setValue('commissionUserMax', '')
    }
    // eslint-disable-next-line
  }, [watch.chargeService])

  const setAmountValue = (value, index, col) => {
    setValue('amounts', watch.amounts.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [col]: value
        }
      }
      return item;
    }))
  }

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Pago de Servicios</div>
          <div className="subtitle">{justPDSProducts ? 'Productos' : currentPDSSegment?.name} </div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          container
          direction="row"
          m={"40px"}
          maxWidth={"70%"}
          justifyContent="center"
          spacing={3}
        >

          {
            type === 'pds' ? (
              <>
                <InputTextFieldGrid
                  xs={watch.fixedAmount ? 12 : 6}
                  name={"name"}
                  control={control}
                  required={"Debes agregar el nombre"}
                  label={"Nombre"}
                />
                {
                  !watch.fixedAmount && <InputTextFieldGrid
                    xs={3}
                    name={"code"}
                    control={control}
                    required={"Debes agregar el código"}
                    label={"SKU"}
                  />
                }
                <InputImageFieldGrid
                  xs={6}
                  name={"logo"}
                  control={control}
                  required={"Debes agregar un logo"}
                  label={"Logo"}
                />
                <InputImageFieldGrid
                  xs={6}
                  name={"imageReceipt"}
                  control={control}
                  label={"Recibo"}
                />
                <InputTextFieldGrid
                  xs={12}
                  name={"instructions"}
                  control={control}
                  multiline={true}
                  label={"Instrucciones"}
                />
                <CheckboxFieldGrid
                  xs={6}
                  name={'referenceVariable'}
                  control={control}
                  label={'Referencia variable'}
                />
                <CheckboxFieldGrid
                  xs={6}
                  name={'referenceAlphaNumeric'}
                  control={control}
                  label={'Referencia alfanumérica'}
                />
                <InputTextFieldGrid
                  xs={6}
                  name={"referenceLength"}
                  control={control}
                  label={"Longitud de referencia"}
                  inputType={"number"}
                  disabled={watch.referenceVariable}
                />
                <InputTextFieldGrid
                  xs={6}
                  name={"referenceName"}
                  control={control}
                  label={"Nombre de referencia"}
                />
                <InputTextFieldGrid
                  xs={12}
                  name={"applicationTime"}
                  control={control}
                  label={"Tiempo de aplicación"}
                />
                <CheckboxFieldGrid
                  xs={3}
                  name={'partialPayments'}
                  control={control}
                  label={'Pagos parciales'}
                />
                <CheckboxFieldGrid
                  xs={3}
                  name={'expiredPayments'}
                  control={control}
                  label={'Pagos vencidos'}
                />
                <CheckboxFieldGrid
                  xs={3}
                  name={'chargeService'}
                  control={control}
                  label={'Cargo por servicio'}
                // disabled={watch.fixedAmount}
                />
                <CheckboxFieldGrid
                  xs={3}
                  name={'fixedAmount'}
                  control={control}
                  label={'Montos fijos'}
                // disabled={watch.chargeService}

                />
                <InputTextFieldGrid
                  xs={4}
                  name={"minPayment"}
                  control={control}
                  label={"Pago mínimo"}
                  inputType={"number"}
                />
                <InputTextFieldGrid
                  xs={4}
                  name={"maxPayment"}
                  control={control}
                  label={"Pago máximo"}
                  inputType={"number"}
                />
                <InputTextFieldGrid
                  xs={4}
                  name={"commissionUserMax"}
                  control={control}
                  label={"Comisión máxima usuario"}
                  inputType={"number"}
                  disabled={!watch.chargeService}
                />
                <InputTextFieldGrid
                  xs={12}
                  name={"customerService"}
                  control={control}
                  multiline={true}
                  label={"Atención a clientes"}
                />
                <Grid container item>
                  {
                    watch.fixedAmount && (
                      <TableData
                        headerButtons={[
                          <CustomButton
                            dark={true}
                            icon={<AddOutlined />}
                            key="add"
                            name={"Agregar"}
                            click={() => setValue('amounts', [...(watch.amounts || []), { amount: '', sku: '', label: '' }])}
                          />,
                        ]}
                        dataRows={watch.amounts || []}
                        dataTitle={["Monto", "SKU", "Etiqueta"]}
                        formatter={({ amount, sku, label }, i) => [
                          {
                            name: "amount",
                            type: "input",
                            value: amount,
                            onBlur: (value) => setAmountValue(value, i, 'amount'),
                            onEnter: (value) => setAmountValue(value, i, 'amount')
                          },
                          {
                            name: "sku",
                            type: "input",
                            value: sku,
                            onBlur: (value) => setAmountValue(value, i, 'sku'),
                            onEnter: (value) => setAmountValue(value, i, 'sku')
                          },
                          {
                            name: "label",
                            type: "input",
                            value: label,
                            onBlur: (value) => setAmountValue(value, i, 'label'),
                            onEnter: (value) => setAmountValue(value, i, 'label')
                          },
                        ]}
                        actions={[
                          {
                            icon: <Close />,
                            label: 'Eliminar',
                            onClick: (row) => {
                              const newAmounts = watch.amounts.filter((item) => item !== row);
                              setValue('amounts', newAmounts);
                            }
                          }
                        ]}
                      />
                    )
                  }
                </Grid>
              </>
            ) : (
              <>
                <InputTextFieldGrid
                  xs={watch.fixedAmount ? 9 : 6}
                  name={"name"}
                  control={control}
                  required={"Debes agregar el nombre"}
                  label={"Nombre"}
                />
                {
                  !watch.fixedAmount && <InputTextFieldGrid
                    xs={3}
                    name={"code"}
                    control={control}
                    required={"Debes agregar el código"}
                    label={"SKU"}
                  />
                }
                <CheckboxFieldGrid
                  xs={3}
                  name={'fixedAmount'}
                  control={control}
                  label={'Montos fijos'}

                />
                <InputImageFieldGrid
                  xs={12}
                  name={"logo"}
                  control={control}
                  required={"Debes agregar un logo"}
                  label={"Logo"}
                />
                <InputTextFieldGrid
                  xs={6}
                  name={"minPayment"}
                  control={control}
                  label={"Pago mínimo"}
                  inputType={"number"}
                />
                <InputTextFieldGrid
                  xs={6}
                  name={"maxPayment"}
                  control={control}
                  label={"Pago máximo"}
                  inputType={"number"}
                />
                <InputTextFieldGrid
                  xs={12}
                  name={"customerService"}
                  control={control}
                  multiline={true}
                  label={"Atención a clientes"}
                />
                <Grid container item>
                  {
                    watch.fixedAmount && (
                      <TableData
                        headerButtons={[
                          <CustomButton
                            dark={true}
                            icon={<AddOutlined />}
                            key="add"
                            name={"Agregar"}
                            click={() => setValue('amounts', [...(watch.amounts || []), { amount: '', sku: '', label: '' }])}
                          />,
                        ]}
                        dataRows={watch.amounts || []}
                        dataTitle={["Monto", "SKU", "Etiqueta"]}
                        formatter={({ amount, sku, label }, i) => [
                          {
                            name: "amount",
                            type: "input",
                            value: amount,
                            onBlur: (value) => setAmountValue(value, i, 'amount'),
                            onEnter: (value) => setAmountValue(value, i, 'amount')
                          },
                          {
                            name: "sku",
                            type: "input",
                            value: sku,
                            onBlur: (value) => setAmountValue(value, i, 'sku'),
                            onEnter: (value) => setAmountValue(value, i, 'sku')
                          },
                          {
                            name: "label",
                            type: "input",
                            value: label,
                            onBlur: (value) => setAmountValue(value, i, 'label'),
                            onEnter: (value) => setAmountValue(value, i, 'label')
                          },
                        ]}
                        actions={[
                          {
                            icon: <Close />,
                            label: 'Eliminar',
                            onClick: (row) => {
                              const newAmounts = watch.amounts.filter((item) => item !== row);
                              setValue('amounts', newAmounts);
                            }
                          }
                        ]}
                      />
                    )
                  }
                </Grid>
              </>
            )
          }
          <Grid item xs={12} display={"flex"} justifyContent={"center"}>
            <CustomButton
              click={handleSubmit(submit)}
              name={"Guardar"}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ProductForm;
